export enum EInputNumberSizeType {
  Large = 'large',
  Middle = 'middle',
  Small = 'small',
}
